<template>
  <v-dialog
    v-model="PrintdialogData"
    width="500"
  >
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Print Preview
      </v-card-title>
      <template v-for="(item,index) in previewArr">
        <img
          style='margin : 2em'
          v-bind:key='index'
          :src="item"
        />
      </template>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-select
          v-model="selectedPrinter"
          :items="printerList"
          label="Select Printer"
          :rules="printerRules"
          required
        ></v-select>
        <v-btn
          :disabled='labels.length === 0'
          color="primary"
          flat
          @click="print()"
        >
          Print
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import config from "../firebaseIDs";
const fb = require('../firebaseConfig.js')
const image2base64 = require('image-to-base64');
export default {
  name: "dymoPrintPreview",
  props: {
    assets: Array
  },
  watch: {
    PrintdialogData: function (val) {
      if (val === false) {
        this.$emit('Modalclose')
      }
    },
  },
  data () {
    return {
      webconfig : config,
      computerLabelURL: "",
      monitorLabelURL : "",
      base64logo: "",
      PrintdialogData: true,
      assetsData: this.assets,
      dymo: null,
      previewArr: [],
      selectedPrinter: "",
      printerList: [],
      labels: [],
      printerRules: [v => !!v || 'Printer is required'],

    }
  },
  mounted () {
    let gsReference ;

    gsReference = fb.storage.refFromURL(
      this.webconfig.webconfig.assetLabelURl);
    gsReference.getDownloadURL().then(url => {
      this.computerLabelURL = url
    });
    gsReference = fb.storage.refFromURL(
      this.webconfig.webconfig.monitorLabelUrl);
    gsReference.getDownloadURL().then(url => {
      this.monitorLabelURL = url
    });

    fb.SettingsCollections.doc("logoURL").get().then((doc) => {
      var gsReference = fb.storage.refFromURL(doc.data().reference)
      gsReference.getDownloadURL().then((url) => { this.imageURL = url

        image2base64(url) // you can also to use url
          .then((response) => {
            this.base64logo = response //cGF0aC90by9maWxlLmpwZw==
            this.printPreview()
          }
          )
      })
    })
    this.$loadScript(this.webconfig.webconfig.dymoJS)
      .then(() => {
        // eslint-disable-next-line
        this.dymo = dymo.label.framework
        var printers = this.dymo.getPrinters();
        for (var i = 0; i < printers.length; i++) {
          var printer = printers[i];
          if (printer.printerType == "LabelWriterPrinter") {
            this.printerList.push(printer.name)
          }
        }

      })



    // this.fetchData()

  },
  methods: {
    prepareLable(element){
      let label ;

      
      switch (element.AssetType){
      case "computer" : 
        label = this.dymo.openLabelFile(this.computerLabelURL)
        label.setObjectText("logo", this.base64logo)
        label.setObjectText("BARCODE", element.Discovery.AssetTag)
        label.setObjectText("serialText", element.Discovery.SystemInfo.Serial)
        label.setObjectText("titleText", element.Discovery.SystemInfo.Make + " " + element.Discovery.SystemInfo.Model)
        label.setObjectText("cpuData", element.Discovery.CpuTitle)
        label.setObjectText("ramText", element.Discovery.RamTitle + " GB")
        label.setObjectText("hddText", element.Discovery.HddTitle + " GB")
        label.setObjectText("qrCode", "URL:https://techspec.app/public/assets/" + element.Discovery.AssetTag)
      break;
      case "monitor" : 
       label = this.dymo.openLabelFile(this.monitorLabelURL)
        label.setObjectText("logo", this.base64logo)
        label.setObjectText("BARCODE", element.Discovery.AssetTag)
        label.setObjectText("serialText", element.Discovery.Serial)
        label.setObjectText("titleText", element.Discovery.monitorID + " " + element.Discovery.Model + " " + element.Discovery.Size + '"')
        label.setObjectText("makeText", element.Discovery.monitorID)
        label.setObjectText("modelText", element.Discovery.Model)
        label.setObjectText("screenSizeText", element.Discovery.Size)
        label.setObjectText("qrCode", "URL:https://techspec.app/public/assets/" + element.Discovery.AssetTag)
      break;
      default:
      throw new TypeError("Cant find label template for type" + element.AssetType);
      break;
      }

      

    return label;
    },
    print () {
      this.labels.forEach(plabel => {
        plabel.print(this.selectedPrinter)
      })
      this.PrintdialogData = false
    },
    printPreview () {
      this.labels = []
      this.assetsData.forEach(element => {
        var label = this.prepareLable(element);
        this.labels.push(label)
        var pngData = label.render()
        var imgURI = "data:image/png;base64," + pngData

        this.previewArr.push(imgURI)

      });




      this.PrintdialogData = true
    }
  }
}
</script>

